// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec79517d","455":"3d34b05b"}[chunkId] + ".chunk.js";
};